
export default {
  'messages.title': 'Mensajes',
  'messages.empty': 'No hay mensajes aún',
  'messages.new': 'Nuevo mensaje',
  'messages.send': 'Enviar',
  'messages.reply': 'Responder',
  'messages.delete': 'Eliminar',
  'messages.confirm_delete': '¿Estás seguro de que quieres eliminar este mensaje?',
  'messages.search': 'Buscar mensajes',
  'messages.load_more': 'Cargar más',
  'messages.typing': 'Escribiendo...',
  'messages.last_seen': 'Último visto',
  'messages.online': 'En línea',
  'messages.offline': 'Desconectado',
  'messages.today': 'Hoy',
  'messages.yesterday': 'Ayer',
  'messages.booking': 'Reserva',
  'messages.booking.request': 'Solicitud de reserva',
  'messages.booking.accepted': 'Reserva aceptada',
  'messages.booking.declined': 'Reserva rechazada',
  'messages.booking.canceled': 'Reserva cancelada',
  'messages.conversation.with': 'Conversación con',
  'messages.start.conversation': 'Iniciar conversación',
  'messages.no.conversations': 'No tienes conversaciones aún',
  'messages.select.conversation': 'Selecciona una conversación',
  'messages.type.message': 'Escribe un mensaje...',
  'messages.message.sent': 'Mensaje enviado',
  'messages.message.error': 'Error al enviar el mensaje',
  'messages.load.error': 'Error al cargar los mensajes',
  'messages.message.placeholder': '¿Qué tienes en mente?',
  'messages.send.button': 'Enviar',
  'messages.back': 'Atrás',
  'messages.verification_required': 'Se requiere verificación para enviar mensajes',
  'messages.subscription_required': 'Se requiere una suscripción para enviar mensajes',
  'messages.report': 'Reportar',
  'messages.block': 'Bloquear',
  'messages.unblock': 'Desbloquear',
  'messages.menu': 'Menú de mensajes'
};
